import React from 'react';

import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import AdminCardImage from '../admin-card-fields/AdminCardImage/AdminCardImage';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminConditionCard.css';

const AdminConditionCard = ({
  condition,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  return (
    <div className='condition__list'>
      <div className='condition-picture-container'>
        <AdminCardImage size='small' img={condition.imageUrl} />
      </div>
      <div className='condition__group'>
        <AdminCardField type='text'>{condition.name}</AdminCardField>
        <div className='admin-condition-buttons'>
          <ContentChangeButton
            iconType='edit'
            onClickHandler={() => onEditClickHandler(condition)}
          />
          <ContentChangeButton
            iconType='delete'
            onClickHandler={() => onDeleteClickHandler(condition)}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminConditionCard;
